"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHideRuleSuppressed(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 16 16' }, props),
        React.createElement("path", { d: 'M5.495 1.692a.592.592 0 0 1 .594-.59h5.96a.592.592 0 1 1-.005 1.184h-5.96a.592.592 0 0 1-.589-.594Zm-3.16.002.92-.92a.454.454 0 0 0-.64-.641l-.92.92-.92-.92a.454.454 0 0 0-.642.641l.92.92-.92.92a.454.454 0 1 0 .641.642l.92-.92.92.92a.454.454 0 1 0 .642-.642l-.92-.92Zm9.709 3.433H6.089a.592.592 0 1 0 0 1.184h5.955a.592.592 0 0 0 0-1.184Zm-9.708.592.92-.92a.454.454 0 0 0-.642-.642l-.92.92-.92-.92a.454.454 0 0 0-.641.642l.92.92-.92.92a.454.454 0 1 0 .641.641l.92-.92.92.92a.454.454 0 0 0 .642-.641l-.92-.92ZM8.56 10.58a5.02 5.02 0 0 1 1.81-.96H6.01c-.33 0-.6.26-.6.59 0 .32.27.59.6.59h2.31c.08-.08.16-.15.24-.22Zm-6.224-.511.92-.92a.454.454 0 0 0-.642-.642l-.92.92-.92-.92a.454.454 0 0 0-.641.642l.92.92-.92.92a.454.454 0 0 0 .641.641l.92-.92.92.92a.454.454 0 1 0 .642-.641l-.92-.92ZM9.91 13.9c-.43-.25-.78-.61-1-1.05.22-.36.5-.68.84-.93a3.64 3.64 0 0 1 2.14-.8c.04-.01.08-.01.12-.01.2-.01.4 0 .59.04l.65-.65c-.24-.06-.48-.1-.73-.11-.09-.01-.19-.02-.28-.02-.08-.01-.16-.01-.23-.01-.36 0-.72.04-1.07.13-.3.07-.6.18-.87.31-.32.15-.61.34-.88.56-.35.29-.66.63-.92 1.01-.1.15-.19.31-.27.48.31.64.77 1.19 1.35 1.61l.56-.56Zm4.79-2.65-.55.55c.4.28.74.63.99 1.05a3.703 3.703 0 0 1-3.09 1.75c-.22-.01-.44-.04-.65-.09l-.65.65c1.06.31 2.2.22 3.2-.26.9-.44 1.62-1.16 2.05-2.05-.31-.62-.75-1.17-1.3-1.6Zm-.26-1.54-5.58 5.58.71.71 5.57-5.59-.7-.7Z' })));
}
exports.default = SvgHideRuleSuppressed;
